export default __webpack_public_path__ + "static/media/logo.6332ffd4.svg";